define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/view/ToolbarPluginToggleButton",
	"csi/xml",
	"csi/xml/Search"
], function(declare,lang,ToolbarPluginToggleButton,xml,Search) {

	return declare(ToolbarPluginToggleButton, {
		// Boolean: indicates if material is special (specific to parent BOM)
		_bSpecial: null,

		// Boolean: indicates if material is disabled either because it is special or referenced by BOM
		_bDisabled: null,

		validatePlugin: function(/*Context*/ctx) {
			// summary: do not show if material is hidden, or if material does not exist (such as on Data Package Template cover sheet)
			var	node = ctx.getNode();
			return node && !node.Hidden;
		},

		enablePlugin: function(/*Context?*/ctx) {
			// summary: actions do not edit, so enable or disable based on if context is present
			this.inherited(arguments);

			// base logic may set widget attribute depending on the node flags/rights
			if (ctx && this.get("disabled"))
				this._bDisabled = true;

			// if special, action is always disabled and has different tooltip
			if (ctx && (this._bSpecial === null)) {
				if (this._bSpecial = ctx.getNode().Special) {
					this._bDisabled = true;
					this.set("title", this.defAction.getString("_Special"));
				}
			}

			if (this._bDisabled === null) {
				// set to disabled for now until we know if it is referenced
				this._setDisabled(this, true);

				// need to query to determine if referenced - in the meantime, disable control
				if (ctx) {
					this._bDisabled = true;

					var	s = new Search().byType("CollectionMaterial").setPageLimits(1,1);
					s.getQuery().RefAttr("Material", xml.OP_EQUALS, ctx.getNodeURL());
					s.execute({
						load: lang.hitch(this, this._onSearch)
					});
				}
			} else {
				// if referenced by BOM, then action is not available
				this._setDisabled(this, !ctx || this._bDisabled);
			}
		},

		_onSearch: function(/*Response*/res) {
			this._bDisabled = !!res.getResultNode() && res.getResultNode().$Type == "CollectionMaterial" ;

			if (this.actionToolbar && this.actionToolbar.view.isStarted()) {
				if (this._bDisabled) {
					this.set("title", this.defAction.getString("_Disabled"));
				} else {
					// call enable again to update toolbar with new status
					this.actionToolbar.enablePlugins();
				}
			}
		},

		isToggledInitially: function(/*Context?*/ctx) {
			// summary: determine toggle status of action
			const node = ctx.getNode();
			return node && node.Managed;
		}
	});
});